// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"oL-z","carouselContainer":"pL-z"};